import AppState, { POPUPS, SCREENS } from '@/js/AppState';
import Button from '@cmp/shared/Button/Button';
import { observer } from 'mobx-react-lite';
import Texts from 'react-sdk/Texts';
import classes from './ScreenHomeAlt.module.css';

import WaveSection from '@/components/shared/WaveSection/WaveSection';
import PopupsManager from 'react-sdk/PopupsManager';
import Footer from '../_layouts/HomeScreens/Footer/Footer';

import logo from "../../../images/logo.png";

import CanvasCharacter from '@/components/Dial/CanvasCharacter/CanvasCharacter';
import { getUrlVar } from 'react-sdk/utils';

const ScreenHomeAlt = () => {
  // gestion de la connexion et passage à l'écran suivant
  function handleClickStart() {
    AppState.setScreen(SCREENS.GAME)
    if (getUrlVar("skipIntro")) {
      AppState.startMainScenario()
    } else {
      PopupsManager.open(POPUPS.INTRO, null, () => {
        AppState.startMainScenario()
      });
    }
  }

  function handleClickFutur() {
    AppState.setScreen(SCREENS.GAME)
    AppState.startFutureScenario()
  }


  return (
    <div className={classes.ScreenHomeAlt} >
      <div className={classes.bgFilter} />

      <WaveSection globalClasses={classes.WaveSection} contentClasses={classes.content} color="#fff">
        <div className={classes.button_ctnr}>
          <div className={classes.title}>{Texts.get("home-title")}</div>
          <div className={classes.title}>
          <Button className={classes.button} onClick={handleClickStart} name="startButton">
            {Texts.get("home-button-play")}
          </Button>
          { AppState.fastMode &&<Button className={classes.button} onClick={handleClickFutur} name="futurButton">
            {Texts.get("home-button-futur-play")}
          </Button> }
          </div>
          <div className={classes.text} dangerouslySetInnerHTML={{ __html: Texts.get("home-content") }} />
        </div>


      </WaveSection>


      <img className={classes.logo} src={logo} />

      <div className={classes.chars}>
        <CanvasCharacter className={classes.mami} char_id="mami" forceShow={true} />
        <CanvasCharacter className={classes.papi} char_id="papi" forceShow={true} />
        <CanvasCharacter className={classes.enfant} char_id="petitFils" forceShow={true} />
      </div>

      <Footer />

    </div>








  );
};

export default observer(ScreenHomeAlt)
